import {Controller} from "@hotwired/stimulus"

class ShowButtonController extends Controller {
  static targets = ["target"]

  action() {
    this.targetTarget.classList.remove("hide")
  }
}

export default ShowButtonController
